<div *ngIf="isRequestForStatusInFlight && bondsman" class="text-center">
    <i id="status-view-spinner" class="fa fa-spinner fa-spin fa-5x text-center"></i>
</div>
<!--
<div *ngIf="errors && bondsman">
    <alert type="danger" *ngFor="let error of errors">{{error}}</alert>
</div>
-->
<div *ngIf="bondsman.showProfessionalLicenseStatusField(bondsman.PROFESSIONAL_BONDSMAN) === true" class="panel-body ">
  <div class="row row-eq-height">
    <div class="col-sm-6 panel panel-default panel-margin-bottom panel-margin-top">
      <div id="bondsmanDetails-status-county-status" class="panel-title ">
        Professional Bondsman License Status to Post Bonds for
        <span class="field-code ">V638 </span>{{bondsman.getLicenseeCountyForTitle()}} County
      </div>
      <div *ngIf="bondsman.getLicenseStatus(bondsman.PROFESSIONAL_BONDSMAN) !== bondsman.PROHIBITED" class="panel-body " id="bondsmanDetails-license-status">
        <span class="field-code ">V604 </span>{{bondsman.getLicenseStatus(bondsman.PROFESSIONAL_BONDSMAN)}}
      </div>
      <div *ngIf="bondsman.getLicenseStatus(bondsman.PROFESSIONAL_BONDSMAN) === bondsman.PROHIBITED" class="panel-body " id="bondsmanDetails-license-status-with-date">
        <span class="field-code ">V604 </span>{{bondsman.getLicenseStatus(bondsman.PROFESSIONAL_BONDSMAN)}} since
        <span class="field-code ">V655 </span>{{bondsman.getLicenseStatusDate(bondsman.PROFESSIONAL_BONDSMAN) | date:'MM/dd/yyyy'}}
      </div>
    </div>
    <div *ngIf="bondsman.getLicenseStatus(bondsman.PROFESSIONAL_BONDSMAN) === bondsman.PROHIBITED" 
          class="col-sm-6 panel panel-default panel-margin-bottom panel-margin-top">
      <div id="bondsmanDetails-status-county-reasons-why-title" class="panel-title ">
        <span class="field-code ">V605 </span>Reason(s) Why Professional Bondsman is Prohibited
      </div>
      <div *ngIf="bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyDoi(bondsman.PROFESSIONAL_BONDSMAN) !== ''" class="panel-body " id="bondsmanDetails-license-reasons-why-list-doi">
        <span class="field-code ">V607 </span>-{{bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyDoi(bondsman.PROFESSIONAL_BONDSMAN)}}
      </div>
      <div *ngIf="bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyStatewide(bondsman.PROFESSIONAL_BONDSMAN) !== ''" class="panel-body " id="bondsmanDetails-license-reasons-why-list-statewide">
        <span class="field-code ">V608 </span>-{{bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyStatewide(bondsman.PROFESSIONAL_BONDSMAN)}}
      </div>
      <div *ngIf="bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyCounty(bondsman.PROFESSIONAL_BONDSMAN) !== ''" class="panel-body " id="bondsmanDetails-license-reasons-why-list-county">
        <span class="field-code ">V609 </span>-{{bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyCounty(bondsman.PROFESSIONAL_BONDSMAN)}}
      </div>
    </div>
  </div>
</div>
<div *ngIf="bondsman.showProfessionalLicenseStatusField(bondsman.SURETY_INSURANCE_COMPANY) === true" class="panel-body ">
  <div class="row row-eq-height">
    <div class="col-sm-6 panel panel-default panel-margin-bottom panel-margin-top">
      <div id="bondsmanDetails-status-county-status" class="panel-title ">
        Insurance Company License Status to Post Bonds for
        <span class="field-code ">V638 </span>{{bondsman.getLicenseeCountyForTitle()}} County
      </div>
      <div *ngIf="bondsman.getLicenseStatus(bondsman.SURETY_INSURANCE_COMPANY) !== bondsman.PROHIBITED" class="panel-body " id="bondsmanDetails-license-status">
        <span class="field-code ">V604 </span>{{bondsman.getLicenseStatus(bondsman.SURETY_INSURANCE_COMPANY)}}
      </div>
      <div *ngIf="bondsman.getLicenseStatus(bondsman.SURETY_INSURANCE_COMPANY) === bondsman.PROHIBITED" class="panel-body " id="bondsmanDetails-license-status-with-date">
        <span class="field-code ">V604 </span>{{bondsman.getLicenseStatus(bondsman.SURETY_INSURANCE_COMPANY)}} since
        <span class="field-code ">V655 </span>{{bondsman.getLicenseStatusDate(bondsman.SURETY_INSURANCE_COMPANY) | date:'MM/dd/yyyy'}}
      </div>
    </div>
    <div *ngIf="bondsman.getLicenseStatus(bondsman.SURETY_INSURANCE_COMPANY) === bondsman.PROHIBITED" 
          class="col-sm-6 panel panel-default panel-margin-bottom panel-margin-top">
      <div id="bondsmanDetails-status-county-reasons-why-title" class="panel-title ">
        <span class="field-code ">V605 </span>Reason(s) Why Insurance Company is Prohibited
      </div>
      <div *ngIf="bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyDoi(bondsman.SURETY_INSURANCE_COMPANY) !== ''" class="panel-body " id="bondsmanDetails-license-reasons-why-list-doi">
        <span class="field-code ">V607 </span>-{{bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyDoi(bondsman.SURETY_INSURANCE_COMPANY)}}
      </div>
      <div *ngIf="bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyStatewide(bondsman.SURETY_INSURANCE_COMPANY) !== ''" class="panel-body " id="bondsmanDetails-license-reasons-why-list-statewide">
        <span class="field-code ">V608 </span>-{{bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyStatewide(bondsman.SURETY_INSURANCE_COMPANY)}}
      </div>
      <div *ngIf="bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyCounty(bondsman.SURETY_INSURANCE_COMPANY) !== ''" class="panel-body " id="bondsmanDetails-license-reasons-why-list-county">
        <span class="field-code ">V609 </span>-{{bondsman.getProfessionalBondsmanOrInsuranceCompanyProhibitedReasonWhyCounty(bondsman.SURETY_INSURANCE_COMPANY)}}
      </div>
    </div>
  </div>
</div>
<div *ngIf="bondsman.getCountyDataForListByType(bondsman.RUNNER).length > 0" class="panel-body">
  <div class="panel panel-default panel-margin-bottom">
    <div id="bondsmanDetails-status-runner-title" class="panel-title">
      Runner for
    </div>
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
      <div class="panel-body ">
        <div class="row ">
          <div class="table-responsive" [class.scroll-hide-xy]="true">
            <table id="bondsmanDetails-status-runner-table" class="table table-condensed table-striped ">
              <thead>
                <th valign=top id="bondsmanDetails-status-runner-table-professional-bondsman-title">
                  Professional Bondsman
                </th>
                <th valign=top id="bondsmanDetails-status-runner-table-license-number-title">
                  Professional Bondsman License Number
                </th>
                <th valign=top id="bondsmanDetails-status-runner-table-runner-status-title">
                  Runner Status to Post Bonds for Listed Professional Bondsman for {{bondsman.getLicenseeCountyForTitle()}} County
                </th>
                <th  valign=top id="bondsmanDetails-status-runner-table-runner-prohibitied-title">
                  <!--
                    *ngIf="bondsman.getIsLicenseTypeProhibited(bondsman.RUNNER) === true"
                  -->
                  Reason(s) Why Runner is Prohibited
                </th>
              </thead>
              <tbody>
                <tr *ngFor="let countyData of bondsman.getCountyDataForListByType(bondsman.RUNNER); let i = index">
                  <td id="bondsmanDetails-status-runnerFor-nameAddress">
                    <div class="table-responsive scroll-hide-xy">
                      <table class="table-nowrap">
                        <tr>
                          <td class="text-align-left">
                            <span class="field-code">V625 </span>
                            {{bondsman.getLicenseeLastFirstMiddleNameFromCounty(countyData)}}
                          </td>
                        </tr>
                        <tr *ngIf="bondsman.getSuretyAddressLine1(countyData)">
                          <td class="text-align-left">
                            <span class="field-code">V644 </span>
                            {{bondsman.getSuretyAddressLine1(countyData)}}
                          </td>
                        </tr>
                        <tr *ngIf="bondsman.getSuretyAddressLine2(countyData)">
                          <td class="text-align-left">
                            <span class="field-code">V645 </span>
                            {{bondsman.getSuretyAddressLine2(countyData)}}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-align-left">
                            <span class="field-code">V646 </span>
                            {{bondsman.getSuretyCityName(countyData)}}
                            <span class="field-code">V647 </span>
                            {{bondsman.getSuretyStateAbbreviation(countyData)}}
                            <span class="field-code">V620 </span>
                            {{bondsman.getSuretyZipCode(countyData)}}
                          </td>
                        </tr>
                        <tr *ngIf="bondsman.getSuretyCountyName(countyData) !== '' && bondsman.getSuretyCountyName(countyData) !== 'ALL'">
                          <td class="text-align-left">
                            <span class="field-code">V654 </span>
                            <span title="{{bondsman.getSuretyCountyName(countyData)}}">{{bondsman.getSuretyCountyName(countyData)}}</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                  <td id="bondsmanDetails-status-runnerFor-LicenseNumberForCounty">
                    <span class="field-code ">V626</span>
                    <a (click)="onViewLicenseNumberSelected(bondsman.getSuretyLicenseNumberForCounty(countyData), bondsman.getCountyStateLicenseNumber(countyData))" class="clickable">
                      {{bondsman.getSuretyLicenseNumberForCounty(countyData)}}</a>
                  </td>
                  <td id="bondsmanDetails-status-runnerFor-StatusToWriteBondsForCounty">
                    <span class="field-code ">V604, V655</span>
                    {{bondsman.getCountyStatus(countyData)}}
                  </td>
                  <td *ngIf="bondsman.getRunnerProhibitReasonsList(countyData).length > 0 ||
                             bondsman.getProfessionalBondsmanLicenseeProhibitReasonsList(countyData).length > 0">                          
                    <div *ngIf="bondsman.getRunnerProhibitReasonsList(countyData).length !== 0">
                      <span class="field-code ">V623 </span>Runner License
                      <ul>
                        <li *ngFor="let reason of bondsman.getRunnerProhibitReasonsList(countyData); let i = index;" id="{{'bondsmanDetails-status-runnerFor->ProhitiedRunnerReason-' + i}}"
                          style="list-style-type:hyphen">
                          {{reason}}</li>
                      </ul>
                    </div>
                    <div *ngIf="bondsman.getProfessionalBondsmanLicenseeProhibitReasonsList(countyData).length !== 0">
                      <span class="field-code ">V624</span>Listed Professional Bondsman Licensee
                      <ul>
                        <li *ngFor="let reason of bondsman.getProfessionalBondsmanLicenseeProhibitReasonsList(countyData); let i = index;" id="{{'bondsmanDetails-status-runnerFor->ProhitiedLicenseReason' + i}}"
                          style="list-style-type:hyphen">
                          {{reason}}</li>
                      </ul>
                    </div>
                  </td>
                  <td *ngIf="bondsman.getRunnerProhibitReasonsList(countyData).length === 0 && 
                      bondsman.getProfessionalBondsmanLicenseeProhibitReasonsList(countyData).length === 0">
                    <span class="field-code ">V624</span>-
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="bondsman.isLicenseeThisType(bondsman.BAIL_AGENT) === true &&
            bondsman.getCountyDataForListByType(bondsman.BAIL_AGENT).length > 0" class="panel-body">
  <div class="panel panel-default panel-margin-bottom">
    <div id="bondsmanDetails-status-bail-agent-title" class="panel-title">
      Bail Agent for
    </div>
  </div>
  <div class="panel-body ">
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
      <div class="panel-body ">
        <div class="row ">
          <div class="table-responsive" [class.scroll-hide-xy]="true">
            <table id="bondsmanDetails-status-bail-agent-table" class="table table-condensed table-striped ">
              <thead>
                <th valign=top id="bondsmanDetails-status-bail-agent-table-insurance-company-title">
                  Insurance Company
                </th>
                <th valign=top id="bondsmanDetails-status-bail-agent-table-insurance-company-license-number-title">
                  Insurance Company License Number
                </th>
                <th valign=top id="bondsmanDetails-status-bail-agent-table-agent-status-title">
                  Bail Agent Status to Write Bonds for Listed Insurance Company for {{bondsman.getLicenseeCountyForTitle()}} County
                </th>
                <th *ngIf="bondsman.showReasonsWhyBailAgentIsProhibitedColumn() === true" valign=top id="bondsmanDetails-status-bail-agent-table-insurance-agent-prohibited-title">
                  Reason(s) Why Bail Agent is Prohibited
                </th>
              </thead>
              <tbody>
                <tr *ngFor="let countyData of bondsman.getCountyDataForListByType(bondsman.BAIL_AGENT); let i = index">
                  <td valign=top id="bondsmanDetails-status-bailAgentFor-nameAddress">
                    <div class="table-responsive scroll-hide-xy">
                      <table class="table-nowrap">
                        <tr>
                          <td class="text-align-left">
                            <span class="field-code">V625 </span>
                            {{bondsman.getBusinessNameFromCounty(countyData)}}
                          </td>
                        </tr>
                        <tr *ngIf="bondsman.getSuretyAddressLine1(countyData)">
                          <td class="text-align-left">
                            <span class="field-code">V644 </span>
                            <span title="{{bondsman.getSuretyAddressLine1(countyData)}}">{{bondsman.getSuretyAddressLine1(countyData)}}</span>
                          </td>
                        </tr>
                        <tr *ngIf="bondsman.getSuretyAddressLine2(countyData)">
                          <td class="text-align-left">
                            <span class="field-code">V645 </span>
                            <span title="{{bondsman.getSuretyAddressLine2(countyData)}}">{{bondsman.getSuretyAddressLine2(countyData)}}</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-align-left">
                            <span class="field-code">V646 </span>
                            <span title="{{bondsman.getSuretyCityName(countyData)}}">{{bondsman.getSuretyCityName(countyData)}}</span>
                            <span class="field-code">V647 </span>
                            <span title="{{bondsman.getSuretyStateAbbreviation(countyData)}}">{{bondsman.getSuretyStateAbbreviation(countyData)}}</span>
                            <span class="field-code">V620 </span>
                            <span title="{{bondsman.getSuretyZipCode(countyData)}}">{{bondsman.getSuretyZipCode(countyData)}}</span>
                          </td>
                        </tr>
                        <tr *ngIf="bondsman.getSuretyCountyName(countyData) !== '' && bondsman.getSuretyCountyName(countyData) !== bondsman.ALL">
                          <td class="text-align-left">
                            <span class="field-code">V654 </span>
                            <span title="{{bondsman.getSuretyCountyName(countyData)}}">{{bondsman.getSuretyCountyName(countyData)}}</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                  <td valign=top id="bondsmanDetails-status-LicenseNumberForCounty">
                    <span class="field-code ">V626</span>
                    <a (click)="onViewLicenseNumberSelected(bondsman.getSuretyLicenseNumberForCounty(countyData), bondsman.getCountyStateLicenseNumber(countyData))" class="clickable">
                      {{bondsman.getSuretyLicenseNumberForCounty(countyData)}}</a>
                  </td>
                  <td valign=top id="bondsmanDetails-status-StatusToWriteBondsForCounty">
                    <span class="field-code ">V604, V655</span>
                    {{bondsman.getCountyStatus(countyData)}}
                  </td>
                  <td *ngIf="bondsman.showReasonsWhyBailAgentIsProhibitedColumn() === true &&
                             (bondsman.getBailAgentProhibitReasonsList(countyData).length > 0 ||
                             bondsman.getInsuranceCompanyProhibitReasonsList(countyData).length > 0)">
                    <div *ngIf="bondsman.getBailAgentProhibitReasonsList(countyData).length !== 0">
                      <span class="field-code ">V623 </span>Bail Agent License
                      <ul>
                        <li *ngFor="let reason of bondsman.getBailAgentProhibitReasonsList(countyData); let i = index;" id="{{'bondsmanDetails-status-bailAgentFor->ProhitiedInsuranceCompanyReason-' + i}}"
                          style="list-style-type:hyphen">
                          {{reason}}</li>
                      </ul>
                    </div>
                    <div *ngIf="bondsman.getInsuranceCompanyProhibitReasonsList(countyData).length !== 0">
                      <span class="field-code ">V624</span>Listed Insurance Company License
                      <ul>
                        <li *ngFor="let reason of bondsman.getInsuranceCompanyProhibitReasonsList(countyData); let i = index;" id="{{'bondsmanDetails-status-bailAgentFor->ProhitiedLicenseReason' + i}}"
                          style="list-style-type:hyphen">
                          {{reason}}</li>
                      </ul>
                    </div>
                  </td>
                  <td *ngIf="bondsman.showReasonsWhyBailAgentIsProhibitedColumn() === true &&
                            (bondsman.getBailAgentProhibitReasonsList(countyData).length === 0 &&
                             bondsman.getInsuranceCompanyProhibitReasonsList(countyData).length === 0)">
                    -
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/licensee-status/licensee-status.component.html